import {AttribClass} from '../../../../../@polygonjs/polygonjs/src/core/geometry/Constant';
import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	// create a sphere
	const sphere = geo.createNode('sphere');
	sphere.p.radius.set(0.5);
	sphere.p.center.set([0.5, 0.5, 0]);

	// copy the uv to the position
	const attribCopy = geo.createNode('attribCopy');
	attribCopy.setAttribClass(AttribClass.POINT);
	attribCopy.setInput(0, sphere);
	attribCopy.p.name.set('uv');
	attribCopy.p.tnewName.set(true);
	attribCopy.p.newName.set('position');

	// flatten the resulting geo
	const transform = geo.createNode('transform');
	transform.setInput(0, attribCopy);
	transform.p.t.z.set(0);

	// create a blend node to blend from the sphere and its uv projected version
	const blend = geo.createNode('blend');
	blend.setInput(0, sphere);
	blend.setInput(1, transform);
	blend.flags.display.set(true);

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [attribCopy],
		autoLayout: true,
	};
}
// export const sopAttribCopy = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/attribCopy`,
// 		createData,
// 		relatedNodes: [AttribCopySopNode],
// 	}),
// ];
